export default __webpack_public_path__ + "static/media/LoginSVG.c31a5466.svg";